import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { InstallationsV2Service } from '../../../../services/orders/installationsV2.service';
import * as wijmoChart from '@grapecity/wijmo.chart';

@Component({
    selector: 'app-installations-status-report',
    templateUrl: './installations-status-report.component.html',
    styleUrls: ['./installations-status-report.component.scss'],
    standalone: false
})
export class InstallationsStatusReportComponent implements AfterViewInit {
  @ViewChild('flexPie', { static: false }) flexPie!: wijmoChart.FlexPie;
  @ViewChild('flexPie2', { static: false }) flexPie2!: wijmoChart.FlexPie;

  loading: boolean = true;
  public pkiOperativesData = [
    { pki: 'Pending Installations', value: 0 },
    { pki: 'Installations Last 30 Days', value: 0 },
    { pki: 'Installations Last 60 Days', value: 0 },
    { pki: 'Installations Last 90 Days', value: '0%' },
    { pki: 'Outdated Installations', value: 0 },
    { pki: 'Restaurants pending installation', value: 0 },
    { pki: 'Restaurants Outdated installation', value: 0 },
    { pki: 'Installations Per Person', value: 0 },
    { pki: '# Tanks installed by size', value: 0 },
    { pki: 'Vendor pending installation', value: 0 }
  ];

public restaurants = [
  'La Olla Feliz',
  'Casa De Palo',
  'Yoyos, Burger',
  'Coyote Negro'
]

public restaurantsOutdatedInstallation = [
'La Olla Feliz',
  'Casa De Palo',
  'Yoyos, Burger',
  'Gastro Night',
  'Cocobanba'
]
 
public installationsPerPerson = [
  {
    name: 'Milena Orjuela',
    installations: 650
  },
  {
    name: 'Breiner Lopez',
    installations: 401
  },
  {
    name: 'Rafael Rodriguez',
    installations: 15
  }
]

public pendingInstallationsPerPerson = [
  {
    name: 'Milena Orjuela',
    pending_installations: 100
  },
  {
    name: 'Breiner Lopez',
    pending_installations: 350
  },
  {
    name: 'Rafael Rodriguez',
    pending_installations: 95
  }
]

public tanksInstallationsBySize = [
  {
    name: '50 GL',
    installations: 321
  },
  {
    name: '100 GL',
    installations: 105
  },
  {
    name: '150 GL',
    installations: 60
  }
]

  oilData = [
    { name: 'Clean', value: 10 },
    { name: 'Waste', value: 0 }
  ];

  paymentData = [
    { name: 'Paid', value: 0 },
    { name: 'Omitted', value: 10 }
  ];

  clientSummaryData: any = {}

  constructor(private installationsV2Service: InstallationsV2Service){

  }


  ngOnInit(){
    this.loadReportData()
  }

  ngAfterViewInit() {
    this.setupModernChartStyles();
  }

  setupModernChartStyles() {
    // Oil Chart - Modern Green & Red
    if (this.flexPie) {
      this.flexPie.palette = ['#10b981', '#ef4444']; // Clean Green, Waste Red
      this.flexPie.plotMargin = 'NaN';
      this.flexPie.innerRadius = 0.65;
      this.flexPie.selectedItemOffset = 0.05;
      this.flexPie.selectedItemPosition = wijmoChart.Position.Top;
    }

    // Payment Chart - Modern Green & Amber
    if (this.flexPie2) {
      this.flexPie2.palette = ['#10b981', '#fb923c']; // Paid Green, Debt Amber
      this.flexPie2.plotMargin = 'NaN';
      this.flexPie2.innerRadius = 0.65;
      this.flexPie2.selectedItemOffset = 0.05;
      this.flexPie2.selectedItemPosition = wijmoChart.Position.Top;
    }
  }

  loadReportData() {
    this.loading = true;
    this.installationsV2Service.getInstallationsReportData().subscribe({
      next: (res: any) => {

        this.pkiOperativesData = [
          { pki: 'Pending Installations', value: res.data.generalTotals?.[0]?.totalPendingNoExpired },
          { pki: 'Installations Last 30 Days', value: res.data.installationsByPeriod?.[0]?.last30Days },
          { pki: 'Installations Last 60 Days', value: res.data.installationsByPeriod?.[0]?.last60Days },
          { pki: 'Installations Last 90 Days', value: res.data.installationsByPeriod?.[0]?.last90Days },
          { pki: 'Outdated Installations', value: res.data.generalTotals?.[0]?.totalDelayedExpired },
          { pki: 'Restaurants Outdated installation', value: res.data.outdatedRestaurants?.length }
        ];
        this.installationsPerPerson = res.data.installationsByPerson
        this.pendingInstallationsPerPerson = res.data.installationsPendingByVendor?.map((item: any) => {
          return {
            name: item._id,
            pending_installations: item.outdated
          }
        })
        this.tanksInstallationsBySize = res.data.tanksInstalledBySize


        this.restaurants = res.data.pendingRestaurants.map((item: any) => item.name)
        this.restaurantsOutdatedInstallation = res.data.outdatedRestaurants.map((item: any) => item.name)
        
        // Re-assign array references to trigger Wijmo change detection
        // when display: none is removed
        this.oilData = [...this.oilData];
        this.paymentData = [...this.paymentData];
        
        this.loading = false;
        
        setTimeout(() => {
          this.setupModernChartStyles();
          if (this.flexPie) this.flexPie.refresh();
          if (this.flexPie2) this.flexPie2.refresh();
        }, 100);
      },
      error: (error) => {
        this.loading = false;
      }
    })
  }

    onFilterChange(event: { startDate: Date | null, endDate: Date | null }): void {
    }
}
